import { v1ApiClient } from '@/services';
import type { RequestBody, ResponseBody } from '@/shared/api/generated';

type SignalsPreviewPath = '/v1/workspaces/{workspace_id}/signals/preview';

type PreviewSignalParams = RequestBody<SignalsPreviewPath, 'post'> & {
  workspace_id: string;
};
export type PreviewSignalResponse = ResponseBody<SignalsPreviewPath, 'post'>;
type PreviewSignalFunction = (
  params: PreviewSignalParams,
) => Promise<PreviewSignalResponse>;

/**
 * Signal 프리뷰 (이슈 변경 예측)
 */
export const previewSignal: PreviewSignalFunction = ({
  workspace_id,
  title,
  definition,
  id,
}) =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/signals/preview`, {
      title,
      definition,
      id,
    })
    .then((res) => res.data);
